module.exports = __webpack_public_path__ + "static/media/consolidated.2d1dfd18.jpg";